import { render, staticRenderFns } from "./RulesSpecialCoin.vue?vue&type=template&id=99b8a4a0&scoped=true&"
import script from "./RulesSpecialCoin.vue?vue&type=script&lang=ts&"
export * from "./RulesSpecialCoin.vue?vue&type=script&lang=ts&"
import style0 from "./RulesSpecialCoin.vue?vue&type=style&index=0&id=99b8a4a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b8a4a0",
  null
  
)

export default component.exports